import humanizeDuration from "humanize-duration";
import moment from "moment";

export const shortEnglishHumanizer = humanizeDuration.humanizer({
    language: "shortEn",
    spacer: "",
    delimiter: " ",
    round: true,
    largest: 3,
    languages: {
        shortEn: {
            y: () => "y",
            mo: () => "mo",
            w: () => "w",
            d: () => "d",
            h: () => "h",
            m: () => "m",
            s: () => "s",
            ms: () => "ms",
        },
    },
});

export const hoursDiffFromNow = date => moment().diff(moment(date), 'hours');

export const fromNow = (date) => moment(date).fromNow();

export const formatDate = (date, format = 'DD MMM YYYY') =>  date ? moment(date).format(format) : '' ;
